import filters from '@/filters/filters.js';
import { contractStatuses } from '@/components/Helpers/Constants/contract.js';
// Recibe un item padre y devuelve el total de los valores de sus items y subitems
export function getParentItemTotalValue(parentItem) {
	const totals = {
		qty: 0,
		unit_cost_uf: 0,
		unit_cost_clp: 0,
		total_cost_uf: 0,
		total_cost_clp: 0
	};

	const parse = (n) => parseFloat(n) || 0;

	if(!parentItem || typeof parentItem !== 'object') {
		return totals;
	}

	if (!Array.isArray(parentItem.items) || parentItem.items.length === 0) {
		const qty = parse(parentItem.qty);
		const uf = parse(parentItem.unit_cost_uf);
		const clp = parse(parentItem.unit_cost_clp);

		totals.qty = qty;
		totals.unit_cost_uf = uf;
		totals.unit_cost_clp = clp;
		totals.total_cost_uf = qty * uf;
		totals.total_cost_clp = qty * clp;

		return totals;
	}

	for (const item of parentItem.items) {
		if (Array.isArray(item.subitems) && item.subitems.length > 0) {
			for (const sub of item.subitems) {
				const qty = parse(sub.qty);
				const uf = parse(sub.unit_cost_uf);
				const clp = parse(sub.unit_cost_clp);

				totals.qty += qty;
				totals.unit_cost_uf += uf;
				totals.unit_cost_clp += clp;
				totals.total_cost_uf += uf * qty;
				totals.total_cost_clp += clp * qty;
			}
		} else {
			const qty = parse(item.qty);
			const uf = parse(item.unit_cost_uf);
			const clp = parse(item.unit_cost_clp);

			totals.qty += qty;
			totals.unit_cost_uf += uf;
			totals.unit_cost_clp += clp;
			totals.total_cost_uf += uf * qty;
			totals.total_cost_clp += clp * qty;
		}
	}

	return totals;
}

export function getParentItemTotalValueMulti(itemsArray = []) {
	const totals = {
		qty: 0,
		unit_cost_uf: 0,
		unit_cost_clp: 0,
		total_cost_uf: 0,
		total_cost_clp: 0
	};

	for (const parentItem of itemsArray) {
		if (Array.isArray(parentItem)) {
			for (const item of parentItem) {
				const itemTotals = getParentItemTotalValue(item);
				totals.qty += itemTotals.qty;
				totals.unit_cost_uf += itemTotals.unit_cost_uf;
				totals.unit_cost_clp += itemTotals.unit_cost_clp;
				totals.total_cost_uf += itemTotals.total_cost_uf;
				totals.total_cost_clp += itemTotals.total_cost_clp;
			}
			continue;
		}
		const itemTotals = getParentItemTotalValue(parentItem);
		totals.qty += itemTotals.qty;
		totals.unit_cost_uf += itemTotals.unit_cost_uf;
		totals.unit_cost_clp += itemTotals.unit_cost_clp;
		totals.total_cost_uf += itemTotals.total_cost_uf;
		totals.total_cost_clp += itemTotals.total_cost_clp;
	}

	return totals;
}

export function getParentItemTotalValueWithTax(parentItem, taxRate = 0, ufValue = 0) {
	if(parentItem?.stage && !parentItem.active) {
		return {
			total_cost_uf: 0,
			total_cost_clp: 0,
			total_cost_uf_taxed: 0,
			tax_value_uf: 0,
			total_cost_clp_taxed: 0,
			tax_value_clp: 0,
		};

	}
	const totals = {...getParentItemTotalValue(parentItem), ...{
		total_cost_uf_taxed: 0,
		tax_value_uf: 0,
		total_cost_clp_taxed: 0,
		tax_value_clp: 0,
	}};
	const costsTableTax = taxRate;
	const finalTaxRate = costsTableTax ? parseFloat(costsTableTax.value) : parseFloat(taxRate);

	let taxMultiplier = 1 +	(finalTaxRate / 100);
	if(costsTableTax.type == 2){
		taxMultiplier = 1 / (1 - (finalTaxRate / 100));
	}

	totals.total_cost_uf_taxed = Math.ceil(totals.total_cost_uf * taxMultiplier);
	totals.tax_value_uf = totals.total_cost_uf_taxed - totals.total_cost_uf;

	totals.total_cost_clp = totals.total_cost_uf * ufValue;

	totals.total_cost_clp_taxed = Math.ceil(totals.total_cost_clp * taxMultiplier);
	totals.tax_value_clp = totals.total_cost_clp_taxed - totals.total_cost_clp;
	return totals;
}

export function getParentItemTotalValueMultiWithTax(itemsArray = [], taxRate = 0, ufValue = 0) {
	const totals = {
		qty: 0,
		unit_cost_uf: 0,
		unit_cost_clp: 0,
		total_cost_uf: 0,
		total_cost_clp: 0,
		total_cost_uf_taxed: 0,
		tax_value_uf: 0,
		total_cost_clp_taxed: 0,
		tax_value_clp: 0,
	};
	for (const parentItem of itemsArray) {
		if (Array.isArray(parentItem)) {
			for (const item of parentItem) {
				const itemTotals = getParentItemTotalValueWithTax(item, taxRate, ufValue);
				totals.qty += itemTotals.qty;
				totals.unit_cost_uf += itemTotals.unit_cost_uf;
				totals.unit_cost_clp += itemTotals.unit_cost_clp;
				totals.total_cost_uf += itemTotals.total_cost_uf;
				totals.total_cost_clp += itemTotals.total_cost_clp;
				totals.total_cost_uf_taxed += itemTotals.total_cost_uf_taxed;
				totals.tax_value_uf += itemTotals.tax_value_uf;
				totals.total_cost_clp_taxed += itemTotals.total_cost_clp_taxed;
				totals.tax_value_clp += itemTotals.tax_value_clp;
			}
			continue;
		}
		const itemTotals = getParentItemTotalValueWithTax(parentItem, taxRate, ufValue);
		totals.qty += itemTotals.qty;
		totals.unit_cost_uf += itemTotals.unit_cost_uf;
		totals.unit_cost_clp += itemTotals.unit_cost_clp;
		totals.total_cost_uf += itemTotals.total_cost_uf;
		totals.total_cost_clp += itemTotals.total_cost_clp;
		totals.total_cost_uf_taxed += itemTotals.total_cost_uf_taxed;
		totals.tax_value_uf += itemTotals.tax_value_uf;
		totals.total_cost_clp_taxed += itemTotals.total_cost_clp_taxed;
		totals.tax_value_clp += itemTotals.tax_value_clp;
	}

	return totals;
}


// Payments

// Recibe un objeto de pago y una tabla de costos, devuelve los totales de los pagos con impuestos
export function getSinglePaymentTotalsWithTax(costsPayment, costsTable) {
  const totals = {
    total_cost_uf: 0,
    total_cost_clp: 0,
    total_cost_uf_taxed: 0,
    tax_value_uf: 0,
    total_cost_clp_taxed: 0,
    tax_value_clp: 0,
  };

  if (!costsPayment || !Array.isArray(costsPayment.payments)) return totals;

  costsPayment.payments.forEach(payment => {
    let totalsProject = {
      total_cost_uf: 0,
      total_cost_clp: 0,
      total_cost_uf_taxed: 0,
      tax_value_uf: 0,
      total_cost_clp_taxed: 0,
      tax_value_clp: 0,
    };

    const taxValue = costsTable.tax;
    const ufValue = costsTable.uf_value?.uf_value;

    switch (payment.item_type) {
      case 'cost_table':
				if(payment.type_item_id == costsTable.id) {
					totalsProject = getParentItemTotalValueMultiWithTax(
						[costsTable, costsTable.surfaces],
						taxValue,
						ufValue
					);
				}
        break;

      case 'reception':
				if(payment.type_item_id == costsTable.reception?.id) {
					totalsProject = getParentItemTotalValueWithTax(
						costsTable.reception,
						taxValue,
						ufValue
					);
				}
        break;

      case 'secondary_project': {
        const project = costsTable.projects.find(p => p.id === payment.type_item_id);
        if (project) {
          totalsProject = getParentItemTotalValueWithTax(project, taxValue, ufValue);
        }
        break;
      }

      case 'stage': {
        const stage = costsTable.stages.find(s => s.id === payment.type_item_id);
        if (stage) {
          totalsProject = getParentItemTotalValueWithTax(stage, taxValue, ufValue);
        }
        break;
      }

      case 'specialty': {
        const specialty = costsTable.specialties.find(s => s.id === payment.type_item_id);
        if (specialty) {
          totalsProject = getParentItemTotalValueWithTax(specialty, taxValue, ufValue);
        }
        break;
      }

      case 'supervisionA': {
				const supervisions = costsTable.supervisions?.supervisions
				// const supervisionsB = costsTable.supervisions?.supervisionsB
        if (supervisions && supervisions.length) {
					totalsProject = {
						total_cost_uf: supervisions.reduce((sum, supervision) => { return sum + (Number(supervision.meters_uf) * Number(supervision.meters) * (Number(supervision.percent) / 100)); }, 0),
						total_cost_clp: supervisions.reduce((sum, supervision) => { return sum + (Number(supervision.meters_clp) * Number(supervision.meters) * (Number(supervision.percent) / 100)); }, 0),
						total_cost_uf_taxed: supervisions.reduce((sum, supervision) => { return sum + (Number(supervision.meters_uf) * Number(supervision.meters) * (Number(supervision.percent) * 1.19 / 100)); }, 0),
						tax_value_uf: supervisions.reduce((sum, supervision) => { return sum + (Number(supervision.meters_uf) * Number(supervision.meters) * (Number(supervision.percent) * 0.19 / 100)); }, 0),
						total_cost_clp_taxed: supervisions.reduce((sum, supervision) => { return sum + (Number(supervision.meters_clp) * Number(supervision.meters) * (Number(supervision.percent) * 1.19 / 100)); }, 0),
						tax_value_clp: supervisions.reduce((sum, supervision) => { return sum + (Number(supervision.meters_clp) * Number(supervision.meters) * (Number(supervision.percent) * 0.19 / 100)); }, 0),
					}
        }
        break;
      }
    }

    const factor = payment.amount / 100;

    totals.total_cost_uf += totalsProject.total_cost_uf * factor;
    totals.total_cost_clp += totalsProject.total_cost_clp * factor;
    totals.total_cost_uf_taxed += totalsProject.total_cost_uf_taxed * factor;
    totals.tax_value_uf += totalsProject.tax_value_uf * factor;
    totals.total_cost_clp_taxed += totalsProject.total_cost_clp_taxed * factor;
    totals.tax_value_clp += totalsProject.tax_value_clp * factor;
  });

  return totals;
}

export function getAllPaymentsTotalsWithTax(costsPayments, costsTable) {
  const totals = {
    total_cost_uf: 0,
    total_cost_clp: 0,
    total_cost_uf_taxed: 0,
    tax_value_uf: 0,
    total_cost_clp_taxed: 0,
    tax_value_clp: 0,
  };

  if (!Array.isArray(costsPayments)) return totals;

  costsPayments.forEach(costsPayment => {
    const singleTotal = getSinglePaymentTotalsWithTax(costsPayment, costsTable);

    totals.total_cost_uf += singleTotal.total_cost_uf;
    totals.total_cost_clp += singleTotal.total_cost_clp;
    totals.total_cost_uf_taxed += singleTotal.total_cost_uf_taxed;
    totals.tax_value_uf += singleTotal.tax_value_uf;
    totals.total_cost_clp_taxed += singleTotal.total_cost_clp_taxed;
    totals.tax_value_clp += singleTotal.tax_value_clp;
  });

  return totals;
}

export function getPaymentToPay(costsPayment, costsTable) {
  const totals = {
    total_cost_uf: 0,
    total_cost_clp: 0,
    total_cost_uf_taxed: 0,
    tax_value_uf: 0,
    total_cost_clp_taxed: 0,
    tax_value_clp: 0,
  };

  if (!costsPayment || !Array.isArray(costsPayment.payments)) {
    return totals;
  }

  // const taxRate = parseFloat(costsTable.tax?.value) || 0;
  // const taxFactor = 1 + taxRate / 100;
  // const ufValue = parseFloat(costsPayment.uf_value?.uf_value) || parseFloat(costsTable.uf_value?.uf_value) || 0;

  const singleTotals = getSinglePaymentTotalsWithTax(costsPayment, costsTable);
	return singleTotals;
	// console.log('singleTotals', singleTotals)
  // // const baseUf = singleTotals.total_cost_uf_taxed;
  // // const baseClp = singleTotals.total_cost_clp_taxed;

  // const adjUf = parseFloat(costsPayment.adjustment_uf) || 0;
  // // const adjClp = parseFloat(costsPayment.adjustment_clp) || 0;

  // totals.total_cost_uf = singleTotals.total_cost_uf - adjUf;
  // totals.total_cost_uf_taxed = singleTotals.total_cost_uf_taxed - adjUf;
  // totals.tax_value_uf = totals.total_cost_uf_taxed - totals.total_cost_uf;

  // totals.total_cost_clp = totals.total_cost_uf * ufValue;
  // totals.total_cost_clp_taxed = totals.total_cost_uf_taxed * ufValue;
  // totals.tax_value_clp = totals.total_cost_clp_taxed - totals.total_cost_clp;

  // return totals;
}

export function getPaymentAdjust(costsPayments) {
  if (!Array.isArray(costsPayments)) {
    return {
      adjustment_uf: 0,
      adjustment_clp: 0
    };
  }

  return costsPayments.reduce((acc, costsPayment) => {
    const uf = parseFloat(costsPayment.adjustment_uf) || 0;
    const clp = parseInt(costsPayment.adjustment_clp) || 0;

    acc.adjustment_uf += uf;
    acc.adjustment_clp += clp;

    return acc;
  }, {
    adjustment_uf: 0,
    adjustment_clp: 0
  });
}

export function getAllPaymentsToPay(costsPayments, costsTable) {
  if (!Array.isArray(costsPayments)) {
    return {
      total_cost_uf: 0,
      total_cost_clp: 0,
      total_cost_uf_taxed: 0,
      tax_value_uf: 0,
      total_cost_clp_taxed: 0,
      tax_value_clp: 0,
    };
  }

  return costsPayments.reduce((acc, costsPayment) => {
    const totals = getPaymentToPay(costsPayment, costsTable);

    acc.total_cost_uf += totals.total_cost_uf;
    acc.total_cost_clp += totals.total_cost_clp;
    acc.total_cost_uf_taxed += totals.total_cost_uf_taxed;
    acc.tax_value_uf += totals.tax_value_uf;
    acc.total_cost_clp_taxed += totals.total_cost_clp_taxed;
    acc.tax_value_clp += totals.tax_value_clp;

    return acc;
  }, {
    total_cost_uf: 0,
    total_cost_clp: 0,
    total_cost_uf_taxed: 0,
    tax_value_uf: 0,
    total_cost_clp_taxed: 0,
    tax_value_clp: 0,
  });
}

export function getPaymentsConfigTable(contract) {
	const costsTable = contract.cost_table;
	if(!costsTable) return '';
	const currentCostsTable = getWorkingCostTable(costsTable);
	const showClpOnly = currentCostsTable?.currency === 2;
	
	let summary_html = '<table border="1" cellpadding="5" cellspacing="5" style="font-size: 13px;border-collapse: collapse; width: 100%;text-transform: uppercase;">' +
			'<thead>' +
					'<tr style="background-color: #f5f5f5;">' +
							'<th colspan="2" style="padding: 4px 10px;text-align: left;">Programación Pagos</th>';
	
	if (showClpOnly) {
		summary_html += '<th style="padding: 4px 10px;text-align: right;max-width: 170px;width: 170px;">CLP</th>';
	} else {
		summary_html += '<th style="padding: 4px 10px;text-align: right;max-width: 170px;width: 170px;">UF</th>';
	}
	
	summary_html += '</tr>' +
			'</thead>' +
			'<tbody>';

	let rows = '';
	let accumulatedTotals = {
		total_cost_uf: 0,
		total_cost_clp: 0,
		total_cost_uf_taxed: 0,
		tax_value_uf: 0,
		total_cost_clp_taxed: 0,
		tax_value_clp: 0,
	};

	// Acumular porcentajes por ítem para detectar si alguno no suma 100%
	const percentageMap = {};
	if (Array.isArray(costsTable.payments)) {
		costsTable.payments.forEach(payment => {
			if (Array.isArray(payment.payments)) {
				payment.payments.forEach(p => {
					const key = p.item_type + '_' + p.type_item_id;
					percentageMap[key] = (percentageMap[key] || 0) + (parseFloat(p.amount) || 0);
				});
			}
		});
	}
	const hasIncompletePercentages = Object.values(percentageMap).length > 0 &&
		Object.values(percentageMap).some(v => Math.round(v) < 100);
	
	if (Array.isArray(costsTable.payments)) {
		costsTable.payments.forEach((payment, index) => {
			// Acumular totales de pago de todas las tablas (principal + project_tables)
			let paymentTotals = {
				total_cost_uf: 0,
				total_cost_clp: 0,
				total_cost_uf_taxed: 0,
				tax_value_uf: 0,
				total_cost_clp_taxed: 0,
				tax_value_clp: 0,
			};
			
			if(costsTable.contract_id == contract.id){
				// Sumar tabla principal
				const mainTotals = getSinglePaymentTotalsWithTax(payment, costsTable);
				paymentTotals.total_cost_uf += mainTotals.total_cost_uf;
				paymentTotals.total_cost_clp += mainTotals.total_cost_clp;
				paymentTotals.total_cost_uf_taxed += mainTotals.total_cost_uf_taxed;
				paymentTotals.tax_value_uf += mainTotals.tax_value_uf;
				paymentTotals.total_cost_clp_taxed += mainTotals.total_cost_clp_taxed;
				paymentTotals.tax_value_clp += mainTotals.tax_value_clp;
			}
			
			// Sumar todas las project_tables
			if (Array.isArray(costsTable.project_tables)) {
				costsTable.project_tables.forEach(projectTable => {
					if(projectTable.contract_id == contract.id){
						const projectTableTotals = getSinglePaymentTotalsWithTax(payment, projectTable);
						paymentTotals.total_cost_uf += projectTableTotals.total_cost_uf;
						paymentTotals.total_cost_clp += projectTableTotals.total_cost_clp;
						paymentTotals.total_cost_uf_taxed += projectTableTotals.total_cost_uf_taxed;
						paymentTotals.tax_value_uf += projectTableTotals.tax_value_uf;
						paymentTotals.total_cost_clp_taxed += projectTableTotals.total_cost_clp_taxed;
						paymentTotals.tax_value_clp += projectTableTotals.tax_value_clp;
					}
				});
			}
			
			const name = payment?.stage?.name ?? '';
			const desc = payment?.stage?.description ?? '';
			const description = name && desc ? `${name} - ${desc}` : name || desc;
			
			rows += '<tr>' +
					'<td colspan="2" style="padding: 4px 10px;text-align: left;">ET' + (index + 1) + ' - Cuota ' + (index + 1) + ': ' + description + '</td>';
			
			if (showClpOnly) {
				rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(paymentTotals.total_cost_clp_taxed) + '</td>';
				accumulatedTotals.total_cost_clp_taxed += paymentTotals.total_cost_clp_taxed;
			} else {
				rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(paymentTotals.total_cost_uf_taxed, 2) + '</td>';
				accumulatedTotals.total_cost_uf += paymentTotals.total_cost_uf;
				accumulatedTotals.total_cost_uf_taxed += paymentTotals.total_cost_uf_taxed;
				accumulatedTotals.tax_value_uf += paymentTotals.tax_value_uf;
			}
			
			rows += '</tr>';
		});
	}

	// Total General con impuesto
	rows += '<tr style="font-weight: bold; background-color: #f0f0f0;">' +
			'<td style="padding: 4px 10px;text-align: right;" colspan="2;">Total</td>';
	
	if (showClpOnly) {
			rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(accumulatedTotals.total_cost_clp_taxed) + '</td>';
	} else {
			rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(accumulatedTotals.total_cost_uf_taxed, 2) + '</td>';
	}
	
	rows += '</tr>';

	if (hasIncompletePercentages) {
		rows += '<tr style="background-color: #FF120B;">' +
			'<td colspan="3" style="padding: 8px 10px; text-align: center; color: white; font-weight: bold; font-size: 12px; letter-spacing: 0.5px;">⚠ Hay elementos cuyos % de pagos no suman 100%</td>' +
			'</tr>';
	}

	const btn_html = '<div id="edit-payments-btn-container" style="text-align: right; margin-bottom: 10px;"><button id="edit-payments-btn" style="padding: 2px 12px; background-color: #524D4D; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 14px;">Programar Pagos</button></div>'

	return '<div id="{cost_table_payments}" contenteditable="false">' + btn_html + summary_html + rows + '</tbody></table></div>';
}

export function getSummarySimpleTable(contract) {
	//Para contratos y anexos
	const costsTable = contract.cost_table;
	if(!costsTable) return '';
	const ufValue = parseFloat(costsTable?.uf_value?.uf_value) || 0;
	const taxValue = costsTable?.tax || 0;
	const ufDate = filters.toDateFormat(costsTable?.uf_value?.date) || '';
	const showClpOnly = costsTable?.currency === 2;
	const ufInfo = ufValue && !showClpOnly ? '<p style="text-align:right;font-size: 12px;font-weight: normal;">UF $' + filters.toThousandFilter(ufValue, 2) + ' al ' + ufDate + '</p>' : '';
	
	let summary_html = ufInfo + '<table border="1" cellpadding="5" cellspacing="5" style="font-size: 13px;border-collapse: collapse; width: 100%;text-transform: uppercase;">' +
			'<thead>' +
					'<tr style="background-color: #f5f5f5;">' +
							'<th style="padding: 4px 10px;text-align: left;"></th>';
	
	if (showClpOnly) {
			summary_html += '<th style="padding: 4px 10px;text-align: right;;max-width: 170px;width: 170px;">Total CLP</th>';
	} else {
			summary_html += '<th style="padding: 4px 10px;text-align: right;max-width: 170px;width: 170px;">Total UF</th>' +
							'<th style="padding: 4px 10px;text-align: right;max-width: 170px;width: 170px;">Valor Referencial CLP</th>';
	}
	
	summary_html += '</tr>' +
			'</thead>' +
			'<tbody>';

	let rows = '';
	
	let neto = 0;
	let taxValueTotal = 0;
	let netoClp = 0;
	let taxValueTotalClp = 0;
	
	if(costsTable.contract_id == contract.id){
		// Main Projects - costsTable + surfaces
		const mainProjectTotals = getParentItemTotalValueMultiWithTax(
			[costsTable, costsTable.surfaces],
			taxValue,
			ufValue
		);
		const mainProjectClp = Math.round(mainProjectTotals.total_cost_clp);
		neto += mainProjectTotals.total_cost_uf;
		taxValueTotal += mainProjectTotals.tax_value_uf;
		netoClp += mainProjectTotals.total_cost_clp;
		taxValueTotalClp += mainProjectTotals.tax_value_clp;

		if(mainProjectTotals.total_cost_uf > 0) {
			rows += '<tr>' +
					'<td style="padding: 4px 10px;text-align: left;">' +
					'<p style="margin: 0;font-weight: bold;text-transform: uppercase;">Proyecto de Arquitectura</p>' +
					'</td>';
			
			if (showClpOnly) {
					rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(mainProjectClp) + '</td>';
			} else {
					rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(mainProjectTotals.total_cost_uf, 2) + '</td>' +
							'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(mainProjectClp) + '</td>';
			}
			
			rows += '</tr>';
		}

		// Recepción
		if (costsTable.reception) {
			const receptionTaxValue = costsTable.tax;
			const receptionUfValue = parseFloat(costsTable.uf_value?.uf_value) || 0;
			const receptionTotals = getParentItemTotalValueWithTax(
					costsTable.reception,
					receptionTaxValue,
					receptionUfValue
			);
			const receptionClp = Math.round(receptionTotals.total_cost_clp);
			neto += receptionTotals.total_cost_uf;
			taxValueTotal += receptionTotals.tax_value_uf;
			netoClp += receptionTotals.total_cost_clp;
			taxValueTotalClp += receptionTotals.tax_value_clp;
			
			if(receptionTotals.total_cost_uf > 0) {
				rows += '<tr>' +
					'<td style="padding: 4px 10px;text-align: left;">' +
					'<p style="margin: 0;font-weight: bold;text-transform: uppercase;">Recepción</p>' +
					'</td>';
				
				if (showClpOnly) {
						rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(receptionClp) + '</td>';
				} else {
						rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(receptionTotals.total_cost_uf, 2) + '</td>' +
								'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(receptionClp) + '</td>';
				}
				
				rows += '</tr>';
			}
		}

		// Etapas
		if (Array.isArray(costsTable.stages)) {
			costsTable.stages.filter(stage => stage.active).forEach(stage => {
				const stageTaxValue = stage?.tax;
				const stageUfValue = parseFloat(stage?.uf_value?.uf_value) || ufValue || 0;
				const stageTotals = getParentItemTotalValueWithTax(stage, stageTaxValue, stageUfValue);
				const stageClp = Math.round(stageTotals.total_cost_clp);
				neto += stageTotals.total_cost_uf;
				taxValueTotal += stageTotals.tax_value_uf;
				netoClp += stageTotals.total_cost_clp;
				taxValueTotalClp += stageTotals.tax_value_clp;
				
				if(stageTotals.total_cost_uf > 0) {
					rows += '<tr>' +
						'<td style="padding: 4px 10px;text-align: left;">' +
						'<p style="margin: 0;font-weight: bold;text-transform: uppercase;">' + (stage?.stage?.name || 'Etapa') + '</p>' +
						'</td>';
					
					if (showClpOnly) {
							rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(stageClp) + '</td>';
					} else {
							rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(stageTotals.total_cost_uf, 2) + '</td>' +
									'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(stageClp) + '</td>';
					}
					
					rows += '</tr>';
				}
			});
		}

		// Especialidades
		if (Array.isArray(costsTable.specialties)) {
			costsTable.specialties.forEach(specialty => {
				const specialtyTaxValue = specialty?.tax;
				const specialtyUfValue = parseFloat(specialty?.uf_value?.uf_value) || ufValue || 0;
				const specialtyTotals = getParentItemTotalValueWithTax(specialty, specialtyTaxValue, specialtyUfValue);
				const specialtyClp = Math.round(specialtyTotals.total_cost_clp);
				neto += specialtyTotals.total_cost_uf;
				taxValueTotal += specialtyTotals.tax_value_uf;
				netoClp += specialtyTotals.total_cost_clp;
				taxValueTotalClp += specialtyTotals.tax_value_clp;
				
				if(specialtyTotals.total_cost_uf > 0) {
					rows += '<tr>' +
						'<td style="padding: 4px 10px;text-align: left;">' +
						'<p style="margin: 0;font-weight: bold;text-transform: uppercase;">' + (specialty?.specialty?.name || 'Especialidad') + '</p>' +
						'</td>';
					
					if (showClpOnly) {
							rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(specialtyClp) + '</td>';
					} else {
							rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(specialtyTotals.total_cost_uf, 2) + '</td>' +
									'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(specialtyClp) + '</td>';
					}
					
					rows += '</tr>';
				}
			});
		}
	}

	// Subtablas de Proyectos (project_tables)
	if (Array.isArray(costsTable.project_tables)) {
		costsTable.project_tables.forEach(projectTable => {
			if(projectTable.contract_id == contract.id){
				const projectTableTaxValue = projectTable?.tax || 0;
				const projectTableUfValue = parseFloat(projectTable?.uf_value?.uf_value) || 0;
				const projectTableMainTotals = getParentItemTotalValueMultiWithTax(
					[projectTable, projectTable.surfaces],
					projectTableTaxValue,
					projectTableUfValue
				);
				const projectTableMainClp = Math.round(projectTableMainTotals.total_cost_clp);
					
				// Acumular para totales
				neto += projectTableMainTotals.total_cost_uf;
				taxValueTotal += projectTableMainTotals.tax_value_uf;
				netoClp += projectTableMainTotals.total_cost_clp;
				taxValueTotalClp += projectTableMainTotals.tax_value_clp;
				
				// Renderizar
				if(projectTableMainTotals.total_cost_uf > 0) {
					rows += '<tr>' +
						'<td style="padding: 4px 10px;text-align: left;">' +
						'<p style="margin: 0;font-weight: bold;text-transform: uppercase;">Proyecto de Arquitectura</p></p>' +
						'</td>';
				
					if (showClpOnly) {
						rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(projectTableMainClp) + '</td>';
					} else {
						rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(projectTableMainTotals.total_cost_uf, 2) + '</td>' +
									'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(projectTableMainClp) + '</td>';
					}
					
					rows += '</tr>';
				}

				if (projectTable.reception) {
					const projectTableReceptionTaxValue = projectTable.tax;
					const projectTableReceptionUfValue = parseFloat(projectTable.uf_value?.uf_value) || 0;
					const receptionTotals = getParentItemTotalValueWithTax(
						projectTable.reception,
						projectTableReceptionTaxValue,
						projectTableReceptionUfValue
					);
					const receptionClp = Math.round(receptionTotals.total_cost_clp);
					neto += receptionTotals.total_cost_uf;
					taxValueTotal += receptionTotals.tax_value_uf;
					netoClp += receptionTotals.total_cost_clp;
					taxValueTotalClp += receptionTotals.tax_value_clp;
					
					if(receptionTotals.total_cost_uf > 0) {
						rows += '<tr>' +
								'<td style="padding: 4px 10px;text-align: left;">' +
								'<p style="font-size: 10px; margin: 0;">' + (projectTable.contract?.parent_contract ? 'Anexo / Adicional' : 'Tabla General') + '</p>' +
								'<p style="margin: 0;font-weight: bold;text-transform: uppercase;">Recepción</p>' +
								'<p style="font-size: 10px; margin: 0;">' + (projectTable.contract?.parent_contract ? 'Anexo: ' : 'Contrato: ') + getProjectCode(projectTable.contract, projectTable?.project) + '</p>' +
								'</td>';
						
						if (showClpOnly) {
								rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(receptionClp) + '</td>';
						} else {
								rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(receptionTotals.total_cost_uf, 2) + '</td>' +
										'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(receptionClp) + '</td>';
						}
						
						rows += '</tr>';
					}
				}

				// Etapas de project_table
				if (Array.isArray(projectTable.stages)) {
					projectTable.stages.filter(stage => stage.active).forEach(stage => {
						const projectTableStageUfValue = parseFloat(projectTable?.uf_value?.uf_value) || 0;
						const stageTaxValue = projectTable?.tax;
						const stageTotals = getParentItemTotalValueWithTax(stage, stageTaxValue, projectTableStageUfValue);
const stageClp = Math.round(stageTotals.total_cost_clp);
					neto += stageTotals.total_cost_uf;
					taxValueTotal += stageTotals.tax_value_uf;
					netoClp += stageTotals.total_cost_clp;
					taxValueTotalClp += stageTotals.tax_value_clp;
						
						if(stageTotals.total_cost_uf > 0) {
							rows += '<tr>' +
									'<td style="padding: 4px 10px;text-align: left;">' +
									'<p style="margin: 0;font-weight: bold;text-transform: uppercase;">' + (stage?.stage?.name || 'Etapa') + '</p>' +
									'</td>';
							
							if (showClpOnly) {
									rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(stageClp) + '</td>';
							} else {
									rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(stageTotals.total_cost_uf, 2) + '</td>' +
											'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(stageClp) + '</td>';
							}
							
							rows += '</tr>';
						}
					});
				}

				// Especialidades de project_table
				if (Array.isArray(projectTable.specialties)) {
					projectTable.specialties.forEach(specialty => {
						const projectTableSpecialtyUfValue = parseFloat(projectTable?.uf_value?.uf_value) || 0;
						const specialtyTaxValue = projectTable?.tax;
						const specialtyTotals = getParentItemTotalValueWithTax(specialty, specialtyTaxValue, projectTableSpecialtyUfValue);
const specialtyClp = Math.round(specialtyTotals.total_cost_clp);
					neto += specialtyTotals.total_cost_uf;
					taxValueTotal += specialtyTotals.tax_value_uf;
					netoClp += specialtyTotals.total_cost_clp;
					taxValueTotalClp += specialtyTotals.tax_value_clp;
						
						if(specialtyTotals.total_cost_uf > 0) {
							rows += '<tr>' +
									'<td style="padding: 4px 10px;text-align: left;">' +
									'<p style="margin: 0;font-weight: bold;text-transform: uppercase;">' + (specialty?.specialty?.name || 'Especialidad') + '</p>' +
									'</td>';
							
							if (showClpOnly) {
								rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(specialtyClp) + '</td>';
							} else {
								rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(specialtyTotals.total_cost_uf, 2) + '</td>' +
											'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(specialtyClp) + '</td>';
							}
							
							rows += '</tr>';
						}
					});
				}
			}
		});
	}

	const total = neto + taxValueTotal;
	const finalNetoClp = Math.round(netoClp);
	const finalTaxClp = Math.round(taxValueTotalClp);
	const totalClp = finalNetoClp + finalTaxClp;
	
	rows += '<tr>' +
			'<td style="padding: 4px 10px;text-align: right;"><b>Total Neto</b></td>';
	
	if (showClpOnly) {
			rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(finalNetoClp) + '</td>';
	} else {
			rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(neto, 2) + '</td>' +
					'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(finalNetoClp) + '</td>';
	}
	
	rows += '</tr>';
			
	// Agregar fila de impuesto
	rows += '<tr>' +
			'<td style="padding: 4px 10px;text-align: right;"><b>' + costsTable.tax?.name + '</b> ' + (costsTable.tax?.value ? costsTable.tax.value+'%' : 0) + '</td>';
	
	if (showClpOnly) {
			rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(finalTaxClp) + '</td>';
	} else {
			rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(taxValueTotal, 2) + '</td>' +
					'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(finalTaxClp) + '</td>';
	}
	
	rows += '</tr>';

	// Total General con impuesto
	rows += '<tr style="font-weight: bold; background-color: #f0f0f0;">' +
			'<td style="padding: 4px 10px;text-align: right;">Total</td>';
	
	if (showClpOnly) {
			rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(totalClp) + '</td>';
	} else {
			rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(total, 2) + '</td>' +
					'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(totalClp) + '</td>';
	}
	
	rows += '</tr>';

	return '<div id="{cost_table_summary}" contenteditable="false">' + summary_html + rows + '</tbody></table></div>';
}

export function getSubcontractSummarySimpleTable(contract) {
	const costsTable = contract.cost_table;
	if (!costsTable) return '';

	const includedSubcontracts = contract?.subcontract_included_info || [];

	const mainProjectSubs = includedSubcontracts.filter(s => s.item_type === 'cost_table');
	const otherSubs = includedSubcontracts.filter(s => s.item_type !== 'cost_table');

	const showClpOnly = costsTable?.currency === 2;
	const taxRate = contract?.info?.tax
	const ufValue = parseFloat(contract?.info?.uf_value?.uf_value) || 0;
	const ufDate = filters.toDateFormat(contract?.info?.uf_value?.date) || '';
	const ufInfo = ufValue && !showClpOnly ? '<p style="text-align:right;font-size: 12px;font-weight: normal;">UF $' + filters.toThousandFilter(ufValue, 2) + ' al ' + ufDate + '</p>' : '';

	if (!includedSubcontracts.length) return '';

	let summary_html = ufInfo + '<table border="1" cellpadding="5" cellspacing="5" style="font-size: 13px;border-collapse: collapse; width: 100%;table-layout: fixed;text-transform: uppercase;">' +
			`<colgroup>
					<col style="width: ${mainProjectSubs.length ? '240px' : '130px'};">
					${!showClpOnly ? `<col style="width: auto;">` : ``}
					<col style="width: auto;">
			</colgroup>` +
			'<thead>' +
					'<tr style="background-color: #f5f5f5;">' +
							'<th style="padding: 4px 10px;text-align: left;"></th>';
							
	if (showClpOnly) {
			summary_html += '<th style="padding: 4px 10px;text-align: right;">Total CLP</th>';
	} else {
			summary_html += '<th style="padding: 4px 10px;text-align: right;">Total UF</th>' +
							'<th style="padding: 4px 10px;text-align: right;">Valor Referencial CLP</th>';
	}
	
	summary_html += '</tr>' +
			'</thead>' +
			'<tbody>';

	let rows = '';
	let totalUf = 0;
	let totalClp = 0;
	let totalTaxValueUf = 0;
	let totalTaxValueClp = 0;

	// Superficie total: suma de items de costsTable.surfaces + project_tables[].surfaces
	let totalSurface = 0;
	if (Array.isArray(costsTable.surfaces?.items) && includedSubcontracts.some(s => String(s.morphable_id) === String(costsTable.id))) {
		totalSurface += costsTable.surfaces.items.reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0);
	}
	if (Array.isArray(costsTable.project_tables)) {
		costsTable.project_tables.forEach(pt => {
			if (Array.isArray(pt.surfaces?.items) && includedSubcontracts.some(s => String(s.morphable_id) === String(pt.id) || String(s.morphable_id) === String(pt.project?.id))) {
				totalSurface += pt.surfaces.items.reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0);
			}
		});
	}

	// Construir processedSubs: 1 entrada merged para los cost_table, luego el resto
	const processedSubs = [];
	if (mainProjectSubs.length > 0) {
		const mergedUfCost = mainProjectSubs.reduce((sum, s) => sum + getSubcontractCostValueUf(costsTable, s), 0);

		// Construir detalle de superficies por subcontrato: matchear tabla origen por morphable_id
		const surfaceDetails = mainProjectSubs.map(s => {
			const code = s.project_code || s._displayName || s.name || '';
			let surface = 0;

			// Primero verificar si corresponde a la tabla principal
			if (String(costsTable.id) === String(s.morphable_id)) {
				if (Array.isArray(costsTable.surfaces?.items)) {
					surface = costsTable.surfaces.items.reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0);
				}
			} else if (Array.isArray(costsTable.project_tables)) {
				for (const pt of costsTable.project_tables) {
					if (String(pt.id) === String(s.morphable_id) || String(pt.project?.id) === String(s.morphable_id)) {
						if (Array.isArray(pt.surfaces?.items)) {
							surface = pt.surfaces.items.reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0);
						}
						break;
					}
				}
			}

			return { project_code: code, surface };
		});

		processedSubs.push({
			...mainProjectSubs[0],
			_precomputedUfCost: mergedUfCost,
			_displayName: 'Proyecto de Arquitectura',
			_totalSurface: totalSurface,
			_surfaceDetails: surfaceDetails
		});
	}
	processedSubs.push(...otherSubs);

	processedSubs.forEach(sub => {
		const subcontractUfCost = sub._precomputedUfCost !== undefined ? sub._precomputedUfCost : getSubcontractCostValueUf(costsTable, sub);
		const subcontractClpCost = subcontractUfCost * ufValue;
		const subTaxValueUf = getTaxFromValue(subcontractUfCost, taxRate);
		const subTaxValueClp = getTaxFromValue(subcontractClpCost, taxRate);
		if (subcontractUfCost > 0) {
			const subName = sub._displayName || sub.name;

			// Si existen detalles de superficie por project_code, renderizarlos y mostrar el total
			let surfaceText = '';
			if (Array.isArray(sub._surfaceDetails) && sub._surfaceDetails.length > 0) {
				surfaceText = sub._surfaceDetails.map(d => '<p style="margin: 2px 0 0;font-weight: normal;font-size: 11px;text-transform: none;">Superficie en: <b>' + d.project_code + '</b>: ' + filters.toThousandFilter(d.surface, 2) + ' m²</p>').join('');
				surfaceText += '<p style="margin: 2px 0 0;font-weight: bold;font-size: 11px;text-transform: none;">Superficie total: ' + filters.toThousandFilter(sub._totalSurface, 2) + ' m²</p>';
			} else {
				surfaceText = sub._totalSurface > 0
					? '<p style="margin: 2px 0 0;font-weight: normal;font-size: 11px;text-transform: none;">' + filters.toThousandFilter(sub._totalSurface, 2) + ' m²</p>'
					: '';
			}

			rows += '<tr>' +
				'<td style="padding: 4px 10px;text-align: left;">' +
				'<p style="margin: 0;font-weight: bold;text-transform: uppercase;">' + subName + '</p>' +
				surfaceText +
				'</td>';
			
			if (showClpOnly) {
				rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(subcontractClpCost) + '</td>';
			} else {
				rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(subcontractUfCost, 2) + '</td>' +
						'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(subcontractClpCost) + '</td>';
			}
			
			rows += '</tr>';

			totalUf += subcontractUfCost;
			totalClp += subcontractClpCost;
			totalTaxValueUf += subTaxValueUf;
			totalTaxValueClp += subTaxValueClp;
		}
	});

	// Calcular impuesto
	const netoUf = totalUf;
	const netoClp = totalClp;
	const taxValueUf = totalTaxValueUf;
	let taxValueClp = totalTaxValueClp;
	const totalWithTaxUf = netoUf + taxValueUf;
	const totalWithTaxClp = netoClp + taxValueClp;
	const adjustment = Math.round(totalWithTaxClp) - (Math.round(netoClp) + Math.round(taxValueClp));
	taxValueClp += adjustment;

	// Fila de Total Neto
	rows += '<tr>' +
			'<td style="padding: 4px 10px;text-align: right;"><b>Total Neto</b></td>';
	
	if (showClpOnly) {
			rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(netoClp) + '</td>';
	} else {
			rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(netoUf, 2) + '</td>' +
					'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(netoClp) + '</td>';
	}
	
	rows += '</tr>';

	// Fila de Impuesto
	rows += '<tr>' +
			'<td style="padding: 4px 10px;text-align: right;"><b>' + `${taxRate.name}${taxRate.value ? ` (${taxRate.value}%)` : ''}` + '</b></td>';
	
	if (showClpOnly) {
			rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(taxValueClp) + '</td>';
	} else {
			rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(taxValueUf, 2) + '</td>' +
					'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(taxValueClp) + '</td>';
	}
	
	rows += '</tr>';

	// Fila de Total
	rows += '<tr style="font-weight: bold; background-color: #f0f0f0;">' +
			'<td style="padding: 4px 10px;text-align: right;">Total</td>';
	
	if (showClpOnly) {
			rows += '<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(totalWithTaxClp) + '</td>';
	} else {
			rows += '<td style="padding: 4px 10px;text-align: right;">' + filters.toThousandFilter(totalWithTaxUf, 2) + '</td>' +
					'<td style="padding: 4px 10px;text-align: right;">$' + filters.toThousandFilter(totalWithTaxClp) + '</td>';
	}
	
	rows += '</tr>';

	return '<div id="{cost_table_subcontract_summary}" contenteditable="false">' + summary_html + rows + '</tbody></table></div>';
}

export function getSubcontractPaymentsTotalsTable(contract) {
	const costTable = contract.cost_table
	const currentCostsTable = getWorkingCostTable(costTable)
	const payments = costTable?.payments || []
	const includedSubcontracts = contract?.subcontract_included_info || []
	const subUfValue = parseFloat(contract?.info?.uf_value?.uf_value) || 0
	const show_clp = currentCostsTable?.currency === 2
	const taxRate = contract?.info?.tax

	if (!payments.length || !includedSubcontracts.length) return ''

	// ---------------------------------------------------------------------------
	// PASO 1: Por cada payment, por cada subcontrato, recopilar sus cuotas.
	// Estructura: paymentQuotas[paymentIndex] = Map<subId, cuota[]>
	// ---------------------------------------------------------------------------
	const paymentQuotas = payments.map(payment => {
		const map = new Map()

		includedSubcontracts.forEach(sub => {
			const subId = `${sub.morphable_type}:${sub.morphable_id}:${sub.item_type}`
			const subcontractUfCost = getSubcontractCostValueUf(costTable, sub)

			const subcontractPayment = payment.subcontract_payments?.find(p =>
				p.morphable_id === sub.morphable_id &&
				p.morphable_type === sub.morphable_type &&
				p.item_type === sub.item_type
			)

			if (!subcontractPayment) {
				map.set(subId, []) // sin cuotas en este payment
				return
			}

			const quotas = []

			if (subcontractPayment.subpayments?.length) {
				subcontractPayment.subpayments.forEach(sp => {
					const percent = Number(sp.amount || 0)
					const ufValue = subcontractUfCost * (percent / 100)
					const clpValue = ufValue * subUfValue
					const taxClpValue = getTaxFromValue(clpValue, taxRate)
					quotas.push({
						title: sp.title || 'Cuota',
						percent,
						ufValue,
						clpValue,
						taxClpValue,
						subUfValue
					})
			})
		} else {
			const percent = Number(subcontractPayment.amount || 0)
			const ufValue = subcontractUfCost * (percent / 100)
			const clpValue = ufValue * subUfValue
			const taxClpValue = getTaxFromValue(clpValue, taxRate)
			quotas.push({
				title: payment.stage?.name || 'Cuota',
				percent,
				ufValue,
				clpValue,
				taxClpValue,
				subUfValue
			})
		}

		map.set(subId, quotas)
	})

	return map
	})

	// ---------------------------------------------------------------------------
	// PASO 2: Calcular cuántas columnas necesita cada payment.
	// Es el máximo de subpayments que tiene cualquier subcontrato dentro de ese payment.
	// Si ningún subcontrato tiene cuota en ese payment, el payment no genera columna.
	// ---------------------------------------------------------------------------
	const paymentColumnCounts = payments.map((_, pIdx) => {
		const map = paymentQuotas[pIdx]
		let max = 0
		map.forEach(quotas => {
			if (quotas.length > max) max = quotas.length
		})
		return max // 0 si ningún subcontrato tiene cuota aquí
	})

	// ---------------------------------------------------------------------------
	// PASO 3: Construir el array de columnas globales.
	// Cada columna sabe: a qué payment pertenece y cuál es su índice dentro del payment.
	// También guardamos el nombre de cada columna para el header.
	// ---------------------------------------------------------------------------
	const columns = [] // { paymentIndex, subIndex, label }
	let cuotaCounter = 0

	payments.forEach((payment, pIdx) => {
		const count = paymentColumnCounts[pIdx]
		for (let s = 0; s < count; s++) {
			cuotaCounter++
			columns.push({
				paymentIndex: pIdx,
				subIndex: s,
				label: `Cuota ${cuotaCounter}`
			})
		}
	})

	if (!columns.length) return ''

	// ---------------------------------------------------------------------------
	// PASO 4: Para cada subcontrato, mapear sus cuotas a la columna global correcta.
	// Resultado: subRows[subIndex] = { sub, cells: [quota | null, ...] , rowTotal }
	// ---------------------------------------------------------------------------
	const subRows = includedSubcontracts.map(sub => {
		const subId = `${sub.morphable_type}:${sub.morphable_id}:${sub.item_type}`
		const cells = columns.map(col => {
			const quotas = paymentQuotas[col.paymentIndex]?.get(subId) || []
			return quotas[col.subIndex] || null
		})

		const rowTotalUf = cells.reduce((sum, c) => sum + (c?.ufValue || 0), 0)
		const rowTotalClp = cells.reduce((sum, c) => sum + (c?.clpValue || 0), 0)
		const rowTotalTaxClp = cells.reduce((sum, c) => sum + (c?.taxClpValue || 0), 0)

		return { sub, cells, rowTotalUf, rowTotalClp, rowTotalTaxClp, subUfValue }
	})

	// ---------------------------------------------------------------------------
	// PASO 4.5: Agrupar todos los subs cost_table en una única fila merged.
	// Las cuotas de cada columna se suman entre todos los subs cost_table.
	// ---------------------------------------------------------------------------
	const mainProjectSubRows = subRows.filter(r => r.sub.item_type === 'cost_table')
	const otherSubRows = subRows.filter(r => r.sub.item_type !== 'cost_table')

	let mergedSubRows = subRows

	if (mainProjectSubRows.length > 0) {
		const totalMergedUfCost = mainProjectSubRows.reduce((sum, r) => sum + r.rowTotalUf, 0)

		// Superficie total para mostrar bajo el nombre
		let totalSurface = 0
		if (Array.isArray(costTable.surfaces?.items) && mainProjectSubRows.some(r => String(r.sub.morphable_id) === String(costTable.id))) {
			totalSurface += costTable.surfaces.items.reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0)
		}
		if (Array.isArray(costTable.project_tables)) {
			costTable.project_tables.forEach(pt => {
				if (Array.isArray(pt.surfaces?.items) && mainProjectSubRows.some(r => String(r.sub.morphable_id) === String(pt.id) || String(r.sub.morphable_id) === String(pt.project?.id))) {
					totalSurface += pt.surfaces.items.reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0)
				}
			})
		}

		const mergedCells = columns.map((_, colIdx) => {
			const cellsForCol = mainProjectSubRows.map(r => r.cells[colIdx]).filter(Boolean)
			if (cellsForCol.length === 0) return null

			const mergedUfValue = cellsForCol.reduce((sum, c) => sum + (c.ufValue || 0), 0)
			const mergedClpValue = cellsForCol.reduce((sum, c) => sum + (c.clpValue || 0), 0)
			const mergedTaxClpValue = cellsForCol.reduce((sum, c) => sum + (c.taxClpValue || 0), 0)
			const effectivePercent = totalMergedUfCost > 0 ? (mergedUfValue / totalMergedUfCost) * 100 : 0

			return {
				title: cellsForCol[0]?.title || 'Cuota',
				percent: effectivePercent,
				ufValue: mergedUfValue,
				clpValue: mergedClpValue,
				taxClpValue: mergedTaxClpValue,
				subUfValue,
			}
		})

		const mergedRowTotalUf = mergedCells.reduce((sum, c) => sum + (c?.ufValue || 0), 0)
		const mergedRowTotalClp = mergedCells.reduce((sum, c) => sum + (c?.clpValue || 0), 0)
		const mergedRowTotalTaxClp = mergedCells.reduce((sum, c) => sum + (c?.taxClpValue || 0), 0)

		// Construir detalle de superficies por subcontrato para mostrar origen de la suma
		const surfaceDetails = mainProjectSubRows.map(r => {
			const s = r.sub
			const code = s.project_code || s.name || ''
			let surface = 0
			if (String(costTable.id) === String(s.morphable_id)) {
				if (Array.isArray(costTable.surfaces?.items)) {
					surface = costTable.surfaces.items.reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0)
				}
			} else if (Array.isArray(costTable.project_tables)) {
				for (const pt of costTable.project_tables) {
					if (String(pt.id) === String(s.morphable_id) || String(pt.project?.id) === String(s.morphable_id)) {
						if (Array.isArray(pt.surfaces?.items)) {
							surface = pt.surfaces.items.reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0)
						}
						break
					}
				}
			}
			return { project_code: code, surface }
		})

		mergedSubRows = [
			{
				sub: { ...mainProjectSubRows[0].sub, name: 'Proyecto de Arquitectura', _totalSurface: totalSurface, _surfaceDetails: surfaceDetails },
				cells: mergedCells,
				rowTotalUf: mergedRowTotalUf,
				rowTotalClp: mergedRowTotalClp,
				rowTotalTaxClp: mergedRowTotalTaxClp,
				subUfValue,
			},
			...otherSubRows,
		]
	}

	// ---------------------------------------------------------------------------
	// PASO 5: Agrupar columnas por payment para el header superior
	// Cada grupo tiene: título del payment y cantidad de columnas (colspan)
	// ---------------------------------------------------------------------------
	const paymentGroups = []
	columns.forEach((col) => {
		const prev = paymentGroups[paymentGroups.length - 1]
		const title = payments[col.paymentIndex]?.stage?.subcontract_stage_detail?.title || `--`

		if (prev && prev.paymentIndex === col.paymentIndex) {
			prev.colspan++
		} else {
			paymentGroups.push({
				paymentIndex: col.paymentIndex,
				title,
				colspan: 1
			})
		}
	})


	const totalColumns = columns.length;
	const fixedWidth = 185;
	const colWidth = `calc((100% - ${fixedWidth}px) / ${totalColumns})`;
	
	// Botón Programación Pagos
	const btn_html = '<div id="edit-subcontract-payments-btn-container" style="text-align: right; margin-bottom: 10px;"><button id="edit-subcontract-payments-btn" style="padding: 2px 12px; background-color: #524D4D; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 14px;">Programar Pagos</button></div>'
	
	// ---------------------------------------------------------------------------
	// PASO 7: Generar HTML
	// ---------------------------------------------------------------------------

	let html = btn_html + `<table border="1" cellpadding="0" cellspacing="0"
			style="font-size:13px;border-collapse:collapse;width:100%;table-layout:fixed;text-transform:uppercase;">
			
			<colgroup>
					<!-- Proyecto -->
					<col style="width: ${mainProjectSubRows.length ? '240px' : '130px'};">
					
					<!-- Columnas dinámicas, todas iguales -->
					${columns.map(() => `<col style="width: ${colWidth};">`).join('')}
					
					<!-- Total -->
					<col style="width: 85px;">
			</colgroup>

			<thead>
					<tr style="background:#eee;">
							<th rowspan="2" style="padding:4px 5px;text-align:left;">Proyecto</th>`

	paymentGroups.forEach((group, index) => {
			html += `
							<th colspan="${group.colspan}" style="padding:4px 5px;text-align:center;">
									<p style="margin:0;font-size:10px;">Etapa ${index + 1}</p>
									<p style="margin:0;font-size:11px;">${group.title}</p>
							</th>`
	})

	html += `
							<th rowspan="2" style="padding:4px 5px;text-align:center;">Total</th>
					</tr>
					<tr style="background:#f5f5f5;">`

	columns.forEach(col => {
			html += `
							<th style="padding:4px 5px;text-align:center;">
									${col.label}
							</th>`
	})

	html += `
				</tr>
			</thead>
			<tbody>
	`

	// PASO 8: Filas de subcontratos
	// let accumulatedNetClp = 0
	let accumulatedTotalClp = 0
	const adjustedColumnTotalsClp = new Array(columns.length).fill(0) // Rastrear totales ajustados por columna
	const columnAdjustmentsClp = new Array(columns.length).fill(0) // Rastrear ajustes aplicados por columna
	mergedSubRows.forEach(({ sub, cells }) => {
		let rowAccumulatedNetClp = 0
		let rowAccumulatedTotalClp = 0
		
		// Primero, calcular todos los valores de cuotas para esta fila
		const quotasWithValues = cells.map(quota => {
			if (!quota || quota.ufValue <= 0) {
				return { quota, tax: 0, displayValue: null }
			}
			const tax = getValueWithTax(quota.clpValue, taxRate)
			return { quota, tax, displayValue: Math.round(tax) }
		})
		
		// Calcular totales y diferencia
		let tempRowTotalClp = 0
		quotasWithValues.forEach(({ displayValue }) => {
			if (displayValue) tempRowTotalClp += displayValue
		})
		
		// Calcular el total esperado basado en el neto
		quotasWithValues.forEach(({ quota }) => {
			if (quota && quota.ufValue > 0) {
				rowAccumulatedNetClp += quota.clpValue
			}
		})
		
		// El total esperado según el tipo de impuesto
		let expectedRowTotalClp = getValueWithTax(rowAccumulatedNetClp, taxRate)
		
		const rowDifference = expectedRowTotalClp - tempRowTotalClp
		
		// Encontrar el índice de la última cuota con valor
		let lastQuotaWithValueIdx = -1
		for (let i = quotasWithValues.length - 1; i >= 0; i--) {
			if (quotasWithValues[i].quota) {
				lastQuotaWithValueIdx = i
				break
			}
		}
		
		// Ahora renderizar las cuotas
		const subSurfaceHtml = (() => {
			if (Array.isArray(sub._surfaceDetails) && sub._surfaceDetails.length > 0) {
				const details = sub._surfaceDetails.map(d => `<br><span style="font-size:10px;font-weight:normal;text-transform:none;">Superficie en: <b>${d.project_code}</b>: ${filters.toThousandFilter(d.surface, 2)} m²</span>`).join('')
				const totalLine = sub._totalSurface > 0 ? `<br><span style="font-size:10px;font-weight:bold;text-transform:none;">Superficie total: ${filters.toThousandFilter(sub._totalSurface, 2)} m²</span>` : ''
				return details + totalLine
			}
			return sub._totalSurface > 0 ? `<br><span style="font-size:10px;font-weight:normal;text-transform:none;">${filters.toThousandFilter(sub._totalSurface, 2)} m²</span>` : ''
		})()
		html += `
			<tr>
				<td style="padding:4px 5px;font-weight:bold;text-align:left;font-size:11px;">
					${sub.name}${subSurfaceHtml}
				</td>
		`

		quotasWithValues.forEach(({ quota, tax }, cellIndex) => {
			let finalValue = Math.round(tax)
			
			// Si es la última cuota con valor y hay diferencia, agregarla
			const isLastQuotaWithValue = cellIndex === lastQuotaWithValueIdx && Math.abs(rowDifference) > 0.01 && Math.abs(rowDifference) <= 1
			if (isLastQuotaWithValue) {
				finalValue += rowDifference
				columnAdjustmentsClp[cellIndex] += rowDifference // Rastrear el ajuste
			}
			
			accumulatedTotalClp += finalValue
			rowAccumulatedTotalClp += finalValue
			adjustedColumnTotalsClp[cellIndex] += finalValue // Aquí se suma el finalValue con el ajuste incluido

			if (!quota || quota.ufValue <= 0) {
				html += `
					<td style="padding:4px 5px;text-align:center;color:#888;">—</td>
				`
				return
			}

			html += `
				<td style="
						padding:4px 5px;
						vertical-align:stretch;
						height: 10px;
				">
					<div style="
							height:100%;
							display:flex;
							flex-direction:column;
							justify-content:space-between;
					">
						<p style="
								margin:0;
								font-size:9px;
								font-weight:normal;
								text-transform:uppercase;
						">
								${quota.title}
						</p>
						<div style="width:100%;">
								<div style="width:100%;height:1px;background:#ccc;margin:3px 0;"></div>
								<p style="
										margin:0;
										font-size:11px;
										white-space:nowrap;
										text-align:right;
								">
										${quota.percent}%
								</p>
								${show_clp ? 
									`${(() => {
											return `
											${tax ? `
												<div>
													<p style="
														margin:0;
														font-size:14px;
														line-height: 12px;
														white-space:nowrap;
														font-weight:bold;
														text-align:right;
													">
															$${filters.toThousandFilter(finalValue, 0)}
													</p>
													${taxRate.value > 0 ? `<p style="margin:0;font-size:8px;font-weight:normal;text-align:right;color: #888;">${taxRate.name} incluido</p>` : ''}
												</div>
											` : ''}`
									})()}`
									:
									`
										<div>
											${(() => {
												const ufWithTax = tax ? (finalValue / quota.subUfValue) : quota.ufValue
												return `
													<p style="
														margin:0;
														font-size:14px;
														line-height: 12px;
														white-space:nowrap;
														font-weight:bold;
														text-align:right;
													">
															UF ${filters.toThousandFilter(ufWithTax, 2)}
													</p>
													${taxRate.value > 0 ? `<p style="margin:0;font-size:8px;font-weight:normal;text-align:right;color: #888;">${taxRate.name} incluido</p>` : ''}
												`
											})()}
										</div>
									`
								}
						</div>
					</div>
				</td>
			`
		})

		const finalRowValueNet = show_clp ? '$'+filters.toThousandFilter(rowAccumulatedNetClp, 0) : 'UF '+filters.toThousandFilter(rowAccumulatedNetClp / subUfValue, 2)
		html += `
			<td style="
				padding:4px 5px;
				text-align:right;
				font-weight:bold;
			">
				<p style="margin:0;font-size:10px;font-weight:normal;text-align:right;color: #888;">Neto</p>
				<p style="
					margin:0;
					font-size:12px;
					line-height: 10px;
					white-space:nowrap;
					font-weight:bold;
					text-align:right;
				">
					${finalRowValueNet}
				</p>
				<p style="margin:5px 0 0 0;font-size:10px;font-weight:normal;text-align:right;color: #888;">Total</p>
				<p style="
					margin:0;
					font-size:14px;
					line-height: 10px;
					white-space:nowrap;
					font-weight:bold;
					text-align:right;
				">
					${(() => {
						if (!show_clp) {
							const ufVal = rowAccumulatedTotalClp / subUfValue;
							return `UF ${filters.toThousandFilter(ufVal, 2)}`;
						} else {
							return `$${filters.toThousandFilter(rowAccumulatedTotalClp, 0)}`;
						}
					})()}
				</p>
				${taxRate.value > 0 ? `<p style="margin:0;font-size:8px;font-weight:normal;text-align:right;color: #888;">${taxRate.name} incluido</p>` : ''}
			</td>
		</tr>
		`
	})

	if(mergedSubRows.length == 1){
		html += `
			</tbody>
		</table>
		`
		return html
	}

	// Fila de totales
	html += `
		<tr style="background:#f5f5f5;font-weight:bold;">
			<td style="padding:4px 5px;text-align:right;">
				Totales
			</td>
	`

		for (let idx = 0; idx < columns.length; idx++) {
		const totalForDisplay = Math.round(adjustedColumnTotalsClp[idx] || 0)
		html += `
			<td style="padding:4px 5px;text-align:right;font-size:14px;">
				${(() => {
					if (!show_clp) {
						const ufVal = totalForDisplay / subUfValue
						return `<p style="margin-bottom: 0px;font-weight:bold;">UF ${filters.toThousandFilter(ufVal, 2)}</p>`
					} else {
						return `<p style="margin-bottom: 0px;font-weight:bold;">$${filters.toThousandFilter(totalForDisplay, 0)}</p>`
					}
				})()}
				${taxRate.value > 0 ? `<p style="margin:0;font-size:8px;font-weight:normal;text-align:right;color: #888;">${taxRate.name} incluido</p>` : ''}
			</td>
		`
	}

	html += `
			<td style="padding:4px 5px;text-align:right;font-size:14px;">
				${(() => {
					const totalWithAdjustment = accumulatedTotalClp
					if (!show_clp) {
						const ufVal = totalWithAdjustment / subUfValue
						return `<p style="margin-bottom: 0px;font-weight:bold;">UF ${filters.toThousandFilter(ufVal, 2)}</p>`
					} else {
						return `<p style="margin-bottom: 0px;font-weight:bold;">$${filters.toThousandFilter(totalWithAdjustment, 0)}</p>`
					}
				})()}
				${taxRate.value > 0 ? `<p style="margin:0;font-size:8px;font-weight:normal;text-align:right;color: #888;">${taxRate.name} incluido</p>` : ''}
			</td>
		</tr>
		</tbody>
	</table>
	`

	return '<div id="{cost_table_subcontract_payments}" contenteditable="false">' + html + '</div>';
}

export function getSubContractBankAccountHtml(contract){
	const subcontract_bank_account_html = contract.contractor?.bank_account
		? `<div id="{subcontract_bank_account_html}" contenteditable="false">
				<p style="margin-bottom:4px;"><b>Banco:</b> ${contract.contractor.bank_account.bank_name}</p>
				<p style="margin-bottom:4px;"><b>Tipo de Cuenta:</b> ${contract.contractor.bank_account.account_type}</p>
				<p style="margin-bottom:4px;"><b>Número de Cuenta:</b> ${contract.contractor.bank_account.account_number}</p>
				<p style="margin-bottom:4px;"><b>Nombre Titular:</b> ${contract.contractor.bank_account.account_holder_name}</p>
				<p style="margin-bottom:4px;"><b>Rut Titular:</b> ${filters.formatRut(contract.contractor.bank_account.account_holder_rut)}</p></div>`
		: 'N/A';
	return subcontract_bank_account_html
}

/**
 * Obtiene el valor total de una tabla de costos sumando todos sus elementos
 * @param {Object} costTable - Tabla de costos completa
 * @returns {Object} Objeto con totales en UF y CLP, con y sin impuestos
 */
export function getCostTableTotal(costTable) {
	const totals = {
		total_cost_uf: 0,
		total_cost_clp: 0,
		total_cost_uf_taxed: 0,
		tax_value_uf: 0,
		total_cost_clp_taxed: 0,
		tax_value_clp: 0,
	};

	if (!costTable || typeof costTable !== 'object') {
		return totals;
	}

	const taxValue = costTable.tax;
	const ufValue = parseFloat(costTable.uf_value?.uf_value) || 0;

	// Proyecto Principal (incluye surfaces)
	const mainProjectTotals = getParentItemTotalValueMultiWithTax(
		[costTable, costTable.surfaces],
		taxValue,
		ufValue
	);
	totals.total_cost_uf += mainProjectTotals.total_cost_uf;
	totals.total_cost_uf_taxed += mainProjectTotals.total_cost_uf_taxed;
	totals.tax_value_uf += mainProjectTotals.tax_value_uf;

	// Recepción
	if (costTable.reception) {
		const receptionTotals = getParentItemTotalValueWithTax(
			costTable.reception,
			taxValue,
			ufValue
		);
		totals.total_cost_uf += receptionTotals.total_cost_uf;
		totals.total_cost_uf_taxed += receptionTotals.total_cost_uf_taxed;
		totals.tax_value_uf += receptionTotals.tax_value_uf;
	}

	// Etapas
	if (Array.isArray(costTable.stages)) {
		costTable.stages.filter(stage => stage.active).forEach(stage => {
			const stageTotals = getParentItemTotalValueWithTax(stage, taxValue, ufValue);
			totals.total_cost_uf += stageTotals.total_cost_uf;
			totals.total_cost_uf_taxed += stageTotals.total_cost_uf_taxed;
			totals.tax_value_uf += stageTotals.tax_value_uf;
		});
	}

	// Especialidades
	if (Array.isArray(costTable.specialties)) {
		costTable.specialties.forEach(specialty => {
			const specialtyTotals = getParentItemTotalValueWithTax(specialty, taxValue, ufValue);
			totals.total_cost_uf += specialtyTotals.total_cost_uf;
			totals.total_cost_uf_taxed += specialtyTotals.total_cost_uf_taxed;
			totals.tax_value_uf += specialtyTotals.tax_value_uf;
		});
	}

	// Proyectos Secundarios
	if (Array.isArray(costTable.projects)) {
		costTable.projects.forEach(project => {
			const projectTotals = getParentItemTotalValueWithTax(project, taxValue, ufValue);
			totals.total_cost_uf += projectTotals.total_cost_uf;
			totals.total_cost_uf_taxed += projectTotals.total_cost_uf_taxed;
			totals.tax_value_uf += projectTotals.tax_value_uf;
		});
	}

	// Supervisiones
	if (costTable.supervisions?.supervisions && costTable.supervisions.supervisions.length) {
		const supervisions = costTable.supervisions.supervisions;
		const supervisionTotals = {
			total_cost_uf: supervisions.reduce((sum, supervision) => {
				return sum + (Number(supervision.meters_uf) * Number(supervision.meters) * (Number(supervision.percent) / 100));
			}, 0),
			total_cost_uf_taxed: supervisions.reduce((sum, supervision) => {
				return sum + (Number(supervision.meters_uf) * Number(supervision.meters) * (Number(supervision.percent) * (1 + taxValue / 100) / 100));
			}, 0),
		};
		supervisionTotals.tax_value_uf = supervisionTotals.total_cost_uf_taxed - supervisionTotals.total_cost_uf;

		totals.total_cost_uf += supervisionTotals.total_cost_uf;
		totals.total_cost_uf_taxed += supervisionTotals.total_cost_uf_taxed;
		totals.tax_value_uf += supervisionTotals.tax_value_uf;
	}

	// Calcular valores en CLP
	totals.total_cost_clp = totals.total_cost_uf * ufValue;
	totals.total_cost_clp_taxed = totals.total_cost_uf_taxed * ufValue;
	totals.tax_value_clp = totals.tax_value_uf * ufValue;

	return totals;
}

// Busca recursivamente un elemento por tipo y ID en la estructura de costsTable
export function findItemInCostsTable(costsTable, itemType, typeItemId) {
	const search = (obj, depth = 0) => {
		if (!obj || typeof obj !== 'object') return null;
		if (depth > 10) return null; // Evitar búsqueda infinita
		
		// Búsqueda según el tipo
		switch(itemType) {
			case 'cost_table':
				// Buscar en project_tables[]
				if (Array.isArray(costsTable.project_tables)) {
					const found = costsTable.project_tables.find(p => p.id === typeItemId);
					if (found) return found;
				}
				// O es la tabla principal si id coincide
				if (costsTable.id === typeItemId) return costsTable;
				break;
				
			case 'secondary_project':
				// Buscar en projects[]
				if (Array.isArray(costsTable.projects)) {
					const found = costsTable.projects.find(p => p.id === typeItemId);
					if (found) return found;
				}
				// O dentro de project_tables[].projects
				if (Array.isArray(costsTable.project_tables)) {
					for (let pt of costsTable.project_tables) {
						if (Array.isArray(pt.projects)) {
							const found = pt.projects.find(p => p.id === typeItemId);
							if (found) return found;
						}
					}
				}
				break;
				
			case 'stage':
				// Buscar en stages[]
				if (Array.isArray(costsTable.stages)) {
					const found = costsTable.stages.find(s => s.id === typeItemId);
					if (found) return found;
				}
				// O dentro de project_tables[].stages
				if (Array.isArray(costsTable.project_tables)) {
					for (let pt of costsTable.project_tables) {
						if (Array.isArray(pt.stages)) {
							const found = pt.stages.find(s => s.id === typeItemId);
							if (found) return found;
						}
					}
				}
				// O dentro de projects[].stages
				if (Array.isArray(costsTable.projects)) {
					for (let proj of costsTable.projects) {
						if (Array.isArray(proj.stages)) {
							const found = proj.stages.find(s => s.id === typeItemId);
							if (found) return found;
						}
					}
				}
				break;
				
			case 'specialty':
				// Buscar en specialties[]
				if (Array.isArray(costsTable.specialties)) {
					const found = costsTable.specialties.find(s => s.id === typeItemId);
					if (found) return found;
				}
				// O dentro de project_tables[].specialties
				if (Array.isArray(costsTable.project_tables)) {
					for (let pt of costsTable.project_tables) {
						if (Array.isArray(pt.specialties)) {
							const found = pt.specialties.find(s => s.id === typeItemId);
							if (found) return found;
						}
					}
				}
				// O dentro de stages[].specialties
				if (Array.isArray(costsTable.stages)) {
					for (let stage of costsTable.stages) {
						if (Array.isArray(stage.specialties)) {
							const found = stage.specialties.find(s => s.id === typeItemId);
							if (found) return found;
						}
					}
				}
				break;
				
			case 'reception':
				// Buscar en reception
				if (costsTable.reception && costsTable.reception.id === typeItemId) {
					return costsTable.reception;
				}
				// O dentro de project_tables[].reception
				if (Array.isArray(costsTable.project_tables)) {
					for (let pt of costsTable.project_tables) {
						if (pt.reception && pt.reception.id === typeItemId) {
							return pt.reception;
						}
					}
				}
				break;
		}
		
		return null;
	};
	
	return search(costsTable);
}

export function getModificationCostProject(contract){
	const costsTable = contract.cost_table;
	let total = {
		uf: 0,
		clp: 0,
		uf_taxed: 0,
		clp_taxed: 0,
	}
	if(!costsTable){
		return total;
	}
	// Buscar en stages[]
	if (Array.isArray(costsTable.stages)) {
		const found = costsTable.stages.find(s => s.stage?.is_modification);
		if (found){
			found.items.forEach(item => {
				const total_uf = item.unit_cost_uf * item.qty;
				total.uf += total_uf || 0;
				total.clp += total_uf * costsTable.uf_value?.uf_value || 0;
				total.uf_taxed += total_uf * costsTable.tax?.value || 0;
				total.clp_taxed += total_uf * costsTable.tax?.value * costsTable.uf_value?.uf_value || 0;
			})
		}
	}
	
	if (Array.isArray(costsTable.project_tables)) {
		for (let pt of costsTable.project_tables) {
			if (Array.isArray(pt.stages)) {
				const found = pt.stages.find(s => s.stage?.is_modification);
				if (found) {
					found.items.forEach(item => {
						const total_uf = item.unit_cost_uf * item.qty;
						total.uf += total_uf || 0;
						total.clp += total_uf * costsTable.uf_value?.uf_value || 0;
						total.uf_taxed += total_uf * costsTable.tax?.value || 0;
						total.clp_taxed += total_uf * costsTable.tax?.value * costsTable.uf_value?.uf_value || 0;
					})
				}
			}
		}
	}
	return total
}


function getProjectCode(contract, project) {
	if(contract?.parent_contract){
		let append = ''
		if(contract.addendum_to_contract_id){
			append = ` - ANX Nº ${contract.addendum_index}`
		}
		else if(contract.subcontract_to_contract_id){
			append = ` - SUB Nº ${contract.subcontract_index}`
		}
		return `${contract.serial?.serial} - LP${project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.parent_contract?.info?.contract_prefix_index} ${append}`
	}
	return `${contract.serial?.serial} - LP${project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.info?.contract_prefix_index}`
}

// function getMainProjectDescription(mainProject){
// 	console.log('getMainProjectDescription mainProject', mainProject)
// 	let items = [];
// 	if (mainProject.surfaces?.items) {
// 		items.push(...mainProject.surfaces.items.map(item => ({ ...item, isFromSurface: true })));
// 	}
// 	if (mainProject.items) {
// 		items.push(...mainProject.items);
// 	}
// 	const description = items.reduce((desc, item) => {
// 		if (!item.name || item.name.trim() === '') return desc;
// 		const itemText = item.isFromSurface && item.qty ? `${item.name} ${item.qty}<span style="text-transform: lowercase!important;">m²</span>` : item.name;
// 		return desc ? `${desc}, ${itemText}` : itemText
// 	}, '') || ''
// 	return description
// }

// Busca la tabla (principal o project_table) que contiene al subcontrato incluido
export function getSubcontractTable(cost_table, included) {
	const typeMap = {
		'cost_table': 'cost_table',
		'reception': 'reception',
		'specialty': 'specialties',
		'stage': 'stages'
	}
	
	// Función auxiliar para buscar en subcontracts_info
	const searchInSubcontractsInfo = (subcontractsInfo) => {
		if (!subcontractsInfo) return false;

		const list = subcontractsInfo[typeMap[included.item_type]];
		if (!list) return false;

		if (Array.isArray(list)) {
			return list.some(
				el => Number(el.morphable_id) === Number(included.morphable_id)
			);
		}

		if (typeof list === 'object') {
			return Number(list.item_id) === Number(included.morphable_id);
		}

		return false;
	}

	// Buscar en la tabla principal
	if (cost_table.subcontracts_info) {
		if (searchInSubcontractsInfo(cost_table.subcontracts_info)) {
			return cost_table;
		}
	}
	
	// Buscar en las subtablas (project_tables)
	if (Array.isArray(cost_table.project_tables)) {
		for (const projectTable of cost_table.project_tables) {
			if (projectTable.subcontracts_info) {
				if (searchInSubcontractsInfo(projectTable.subcontracts_info)) {
					return projectTable;
				}
			}
		}
	}
	
	// Si no encuentra, devuelve la tabla principal
	return cost_table;
}

function getSubcontractCostValueUf(cost_table, included) {
	const typeMap = {
		'cost_table': 'cost_table',
		'reception': 'reception',
		'specialty': 'specialties',
		'stage': 'stages'
	}
	
	// Función auxiliar para buscar en subcontracts_info
	const searchInSubcontractsInfo = (subcontractsInfo) => {
		if (!subcontractsInfo) return null;

		const list = subcontractsInfo[typeMap[included.item_type]];
		if (!list) return null;

		if (Array.isArray(list)) {
			return list.find(
				el => Number(el.morphable_id) === Number(included.morphable_id)
			);
		}

		if (typeof list === 'object') {
				const isMatch = Number(list.item_id) === Number(included.morphable_id);
				return isMatch ? list : null;
		}

		return null;
	}
	if (cost_table.subcontracts_info) {
		const found = searchInSubcontractsInfo(cost_table.subcontracts_info);
		if (found) {
			return Number(found.cost_value_uf || 0);
		}
	}
	
	if (Array.isArray(cost_table.project_tables)) {
		for (const projectTable of cost_table.project_tables) {
			if (projectTable.subcontracts_info) {
				const found = searchInSubcontractsInfo(projectTable.subcontracts_info);
				if (found) {
					return Number(found.cost_value_uf || 0);
				}
			}
		}
	}
	
	return 0;
}

function getWorkingCostTable(costs_table){
	if(!costs_table) return null
	if(costs_table.project_tables?.length){
		const foundIndex = costs_table.project_tables
																			.findIndex(ptable => {
																				return ptable.contract?.last_status?.status != contractStatuses.FIRMADO_AMBAS_PARTES
																			})
		if(foundIndex != -1){
			return costs_table.project_tables[foundIndex]
		}
	}
	return costs_table
}


function getTaxFromValue(valueWithoutTax, tax){
	if(tax.type == 1){
		return valueWithoutTax * (tax.value / 100);
	}
	else if(tax.type == 2){
		return getValueWithTax(valueWithoutTax, tax) - valueWithoutTax;
	}
}

function getValueWithTax(valueWithoutTax, tax){
	if(tax.type == 1){
		return valueWithoutTax * (1 + (tax.value / 100));
	}
	else if(tax.type == 2){
		return valueWithoutTax / (1 - (tax.value / 100));
	}
}

/**
 * Valida si todos los pagos de una tabla de costos están configurados al 100%
 * Verifica que cost_table, reception, stages y specialties tengan pagos que sumen 100%
 * @param {Object} costsTable - Tabla de costos a validar
 * @returns {Object} Objeto con detalles de la validación
 * @returns {boolean} result.isValid - Indica si todos los elementos tienen 100% de pagos
 * @returns {Object} result.summary - Resumen de cobertura por elemento
 * @returns {Array} result.errors - Array de mensajes de error si hay elementos sin cobertura completa
 */
export function validatePaymentsFullyCovered(costsTable) {
	const result = {
		isValid: true,
		summary: {},
		errors: []
	};

	if (!costsTable || !Array.isArray(costsTable.payments)) {
		result.isValid = false;
		result.errors.push('No hay pagos configurados en la tabla de costos');
		return result;
	}

	// Extraer todos los pagos del array de objetos payments (cada uno tiene un array payments)
	const allPayments = [];
	costsTable.payments.forEach(paymentGroup => {
		if (Array.isArray(paymentGroup.payments)) {
			allPayments.push(...paymentGroup.payments);
		}
	});

	if (allPayments.length === 0) {
		result.isValid = false;
		result.errors.push('No hay pagos configurados en la tabla de costos');
		return result;
	}

	// Helper para calcular el porcentaje total de pagos para un item_type específico
	const calculatePaymentCoverage = (itemType, typeItemId = null) => {
		return allPayments
			.filter(payment => {
				if (payment.item_type !== itemType) return false;
				// Si se especifica un type_item_id, solo contar pagos para ese item
				return typeItemId === null || payment.type_item_id === typeItemId;
			})
			.reduce((sum, payment) => sum + (parseFloat(payment.amount) || 0), 0);
	};

	// Validar cost_table
	const costTableCoverage = calculatePaymentCoverage('cost_table', costsTable.id);
	result.summary.cost_table = {
		coverage: costTableCoverage,
		isCovered: costTableCoverage === 100
	};
	if (costTableCoverage !== 100) {
		result.isValid = false;
		result.errors.push(`Tabla de Costos: ${costTableCoverage}% (falta ${100 - costTableCoverage}%)`);
	}

	// Validar reception
	if (costsTable.reception) {
		const receptionCoverage = calculatePaymentCoverage('reception', costsTable?.reception?.id);
		result.summary.reception = {
			coverage: receptionCoverage,
			isCovered: receptionCoverage === 100
		};
		if (receptionCoverage !== 100) {
			result.isValid = false;
			result.errors.push(`Recepción: ${receptionCoverage}% (falta ${100 - receptionCoverage}%)`);
		}
	}

	// Validar stages
	if (Array.isArray(costsTable.stages) && costsTable.stages.length > 0) {
		result.summary.stages = {};
		costsTable.stages.filter(stage => stage.active).forEach(stage => {
			const stageCoverage = calculatePaymentCoverage('stage', stage.id);
			const stageName = stage.name || `Stage ${stage.id}`;
			result.summary.stages[stage.id] = {
				name: stageName,
				coverage: stageCoverage,
				isCovered: stageCoverage === 100
			};
			if (stageCoverage !== 100) {
				result.isValid = false;
				result.errors.push(`${stageName} (Stage): ${stageCoverage}% (falta ${100 - stageCoverage}%)`);
			}
		});
	}

	// Validar specialties
	if (Array.isArray(costsTable.specialties) && costsTable.specialties.length > 0) {
		result.summary.specialties = {};
		costsTable.specialties.forEach(specialty => {
			const specialtyCoverage = calculatePaymentCoverage('specialty', specialty.id);
			const specialtyName = specialty.name || `Specialty ${specialty.id}`;
			result.summary.specialties[specialty.id] = {
				name: specialtyName,
				coverage: specialtyCoverage,
				isCovered: specialtyCoverage === 100
			};
			if (specialtyCoverage !== 100) {
				result.isValid = false;
				result.errors.push(`${specialtyName} (Especialidad): ${specialtyCoverage}% (falta ${100 - specialtyCoverage}%)`);
			}
		});
	}

	return result;
}

/**
 * Compares two complex objects and returns their differences
 * @param {Object} oldObj - Original object
 * @param {Object} newObj - New object to compare against
 * @param {string} path - Internal path tracker (used in recursion)
 * @returns {Array} Array of change objects
 */
function isIgnoredPath(p) {
	if (!p) return false;
	return p.indexOf('updated_at') !== -1;
}

export function deepDiff(oldObj, newObj, path = '') {
	const changes = [];

	// Get all unique keys from both objects
	const allKeys = new Set([
		...Object.keys(oldObj ?? {}),
		...Object.keys(newObj ?? {}),
	]);

  for (const key of allKeys) {
	const currentPath = path ? `${path}.${key}` : key;
	// Ignorar cualquier cambio en campos updated_at
	if (isIgnoredPath(currentPath)) continue;
	const oldVal = oldObj?.[key];
	const newVal = newObj?.[key];

    // Key deleted
    if (!(key in (newObj ?? {}))) {
      changes.push({
        type: 'deleted',
        path: currentPath,
        oldValue: oldVal,
        newValue: undefined,
      });
      continue;
    }

    // Key added
    if (!(key in (oldObj ?? {}))) {
      // Si el valor nuevo es undefined, JSON.stringify lo eliminaría igual que si la key no existiera.
      // No reportar como cambio para evitar falsos positivos en el watcher (loop infinito).
      if (newVal !== undefined) {
        changes.push({
          type: 'added',
          path: currentPath,
          oldValue: undefined,
          newValue: newVal,
        });
      }
      continue;
    }

    const oldType = getType(oldVal);
    const newType = getType(newVal);

    // Type changed
    if (oldType !== newType) {
      changes.push({
        type: 'type_changed',
        path: currentPath,
        oldValue: oldVal,
        newValue: newVal,
        oldType,
        newType,
      });
      continue;
    }

    // Both are objects → recurse
    if (oldType === 'object') {
      changes.push(...deepDiff(oldVal, newVal, currentPath));
      continue;
    }

    // Both are arrays → compare
    if (oldType === 'array') {
      changes.push(...diffArrays(oldVal, newVal, currentPath));
      continue;
    }

    // Primitive comparison
    if (oldVal !== newVal) {
      changes.push({
        type: 'modified',
        path: currentPath,
        oldValue: oldVal,
        newValue: newVal,
      });
    }
  }

  return changes;
}

/**
 * Compares two arrays, detecting item-level changes
 */
function diffArrays(oldArr, newArr, path) {
  const changes = [];
  const maxLen = Math.max(oldArr.length, newArr.length);

  for (let i = 0; i < maxLen; i++) {
    const itemPath = `${path}[${i}]`;
    const oldItem = oldArr[i];
    const newItem = newArr[i];

    if (i >= oldArr.length) {
      changes.push({ type: 'added', path: itemPath, oldValue: undefined, newValue: newItem });
    } else if (i >= newArr.length) {
      changes.push({ type: 'deleted', path: itemPath, oldValue: oldItem, newValue: undefined });
    } else {
      const oldType = getType(oldItem);
      const newType = getType(newItem);

      if (oldType !== newType) {
        changes.push({ type: 'type_changed', path: itemPath, oldValue: oldItem, newValue: newItem });
      } else if (oldType === 'object') {
        changes.push(...deepDiff(oldItem, newItem, itemPath));
      } else if (oldType === 'array') {
        changes.push(...diffArrays(oldItem, newItem, itemPath));
      } else if (oldItem !== newItem) {
        changes.push({ type: 'modified', path: itemPath, oldValue: oldItem, newValue: newItem });
      }
    }
  }

  return changes;
}

function getType(val) {
  if (val === null) return 'null';
  if (Array.isArray(val)) return 'array';
  return typeof val; // 'object', 'string', 'number', 'boolean', etc.
}